import React from 'react';

interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

interface SelectProps {
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLSelectElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLSelectElement>) => void;
  required?: boolean;
  disabled?: boolean;
  id?: string;
  name?: string;
  label?: string;
  placeholder?: string;
  error?: string;
  className?: string;
  fullWidth?: boolean;
  size?: 'sm' | 'md' | 'lg';
  options: SelectOption[];
}

export default function Select({
  value,
  onChange,
  onBlur,
  onFocus,
  required = false,
  disabled = false,
  id,
  name,
  label,
  placeholder,
  error,
  className = '',
  fullWidth = true,
  size = 'md',
  options
}: SelectProps) {
  const baseClasses = 'border border-border-light rounded-md focus:ring-2 focus:ring-trust-blue/20 focus:border-trust-blue transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed bg-white';

  const sizeClasses = {
    sm: 'px-3 py-2 text-supporting',
    md: 'px-4 py-3 text-body-lg',
    lg: 'px-5 py-4 text-body-lg'
  };

  const widthClass = fullWidth ? 'w-full' : '';
  const errorClass = error ? 'border-error-red focus:border-error-red focus:ring-error-red/20' : '';

  const selectClasses = `${baseClasses} ${sizeClasses[size]} ${widthClass} ${errorClass} ${className}`;

  return (
    <div className={fullWidth ? 'w-full' : ''}>
      {label && (
        <label
          htmlFor={id}
          className="block text-supporting font-medium text-gray-700 mb-2"
        >
          {label}
          {required && <span className="text-error-red ml-1">*</span>}
        </label>
      )}

      <select
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        required={required}
        disabled={disabled}
        className={selectClasses}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}

        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
            disabled={option.disabled}
          >
            {option.label}
          </option>
        ))}
      </select>

      {error && (
        <p className="text-error-red text-supporting mt-1">
          {error}
        </p>
      )}
    </div>
  );
}